module.exports = __webpack_public_path__ + "img/swipe (1).953fe3bd.jpg";